import { FC, Fragment, useEffect } from 'react'
import { useParams } from 'react-router-dom';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Async
import { getResult } from 'store/player/playerAsync';
// Selectors
import { selectResult } from 'store/player/playerSelectors';
// Components
import PublicDevicePlayable from 'components/PublicDevicePlayable';
import AppBar from 'components/AppBar';
import PlayerResult from 'components/PlayerResult';
import { Button } from 'components/Buttons';
// Hooks
import useNavigateTo from 'hooks/useNavigateTo';
// 
import TextCountdown from './TextCountdown';
// i18next
import { useTranslation } from 'react-i18next';

const QuizGroupPage:FC = () => {
  const { t } = useTranslation('common');

  const { groupSlug } = useParams<{ groupSlug:string }>();
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const result:any = useAppSelector(selectResult);
  
  const navigateTo = useNavigateTo();

  useEffect(() => {
    dispatch(getResult({ quizGroupName: groupSlug, limit: 96 }))
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if ( result && result.quizGroup ){
      // Set default primary
      document.documentElement.style.setProperty('--primaryColor', result.quizGroup.primaryColor);
    }
    // eslint-disable-next-line
  }, [result])

  const handleClick = () => {
    navigateTo('quiz-group-leaderboard');
  }

  if ( !result || !result.quizGroup ) return null;
  return (
    <Fragment>
      <PublicDevicePlayable />
      <AppBar  />
      <div className="grow p-4 overflow-y-auto">
        <div className="mb-4">
          <h1 className="font-bold text-lg text-center">{result.quizGroup.name}</h1>
        </div>
        <TextCountdown
          quizzes={result.quizGroup.quizzes}
          prizes={result.quizGroup.prizes || []}
          results={result.results || []}
        />
        <div className="text-center mb-4 mt-4">
          <Button
            className="capitalize"
            onClick={handleClick}
          >{t('common.leaderboard')}</Button>
        </div>
        {result.quizGroup.callToActionLinkUrl ? (
          <Fragment>
            {result.quizGroup.callToActionImageUrl ? (
              <a
                className="block shadow-neu-content rounded mb-4 p-2"
                href={result.quizGroup.callToActionLinkUrl}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={result.quizGroup.callToActionImageUrl}
                  alt={result.quizGroup.callToActionButtonText || `${t('common.sisit')} ${result.quizGroup.slug}`}
                />
              </a>
            ) : null}
            <div className="text-center">
              <a
                className="
                  inline-block
                  rounded-2xl
                  shadow-neu active:shadow-neu-inner
                  font-semibold
                  py-2 px-4
                  hover:bg-none bg-primary hover:bg-primary text-white
                "
                href={result.quizGroup.callToActionImageUrl}
                target="_blank"
                rel="noreferrer"
              >{result.quizGroup.callToActionButtonText || `${t('common.sisit')} ${result.quizGroup.slug}`}</a>
            </div>
          </Fragment>
        ) : null}
      </div>
      <PlayerResult />
    </Fragment>
  )
}

export default QuizGroupPage;
